export default __webpack_public_path__ + "static/media/refectori-espleni-04.2b377083.jpg";